import * as React from 'react';
import styled from 'styled-components';
import { Content } from '../components/content';
import { Header } from '../components/header/header';
import { Page } from '../components/page';

const StyledSection = styled.section`
  padding: 2rem;
`;

export default function PageNotFound() {
  return (
    <Page data-type="page" data-page-name="page-not-found">
      <Header />
      <Content>
        <StyledSection>
          <h1>Page Not Found</h1>
          <div>The requested page does not exist.</div>
        </StyledSection>
      </Content>
    </Page>
  );
}
